import DatatableController, { responsiveModal } from "./datatable_base"

export default class extends DatatableController {
  get tableSelector() {
    return ".datatables-basic-export-dropdown"
  }

  datatableOptions() {
    return {
      order: [[0, "desc"]],
      dom: "Bfrtip",
      displayLength: 100,
      lengthMenu: [25, 50, 75, 100],
      buttons: [
        {
          extend: "copy",
          text: '<div class="dropdown-item ps-1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="o-ico me-4px"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg> Copier les observations</div>',
          className: "buttonToLink text-green-dark-background text-ft-16 text-weight-400",
          exportOptions: { columns: "*" }
        }
      ],
      responsive: responsiveModal(),
      bFilter: false,
      bInfo: false,
      lengthChange: false,
      paging: false,
      ordering: false,
      info: false
    }
  }
}
